import { render } from "./AddBankCard.vue?vue&type=template&id=3d312995&scoped=true"
import script from "./AddBankCard.vue?vue&type=script&lang=js"
export * from "./AddBankCard.vue?vue&type=script&lang=js"

import "./AddBankCard.vue?vue&type=style&index=0&id=3d312995&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d312995"]])

export default __exports__